'use strict';

import { getCookie } from '../common/helpers.js'

/**
 * Send a POST request.
 *
 * Parameters:
 *
 * url: the endpoint.
 * method: 'GET' or 'POST'
 * data: the data to send. This will be sent as JSON or form values if that
 *   option is set (see below).
 * success: a callback or list of callbacks for successful responses.
 * error: a callback or list of callbacks for unsuccessful responses. The raw
 *   response, status_code and original request parameters are sent with the
 *   callback.
 * expected_response_type: set to 'json' to decode the data.
 * send_as_form_values: set to send the data as form data rather than a JSON
 *   encoded string.
 */
export const ajaxRequest = function (parameters) {

  function callErrorCallbacks() {

    // Do nothing if no error callbacks were provided.
    if (typeof(parameters.error) == 'undefined') {
      return;
    }

    // Allow for either a single function or list of callbacks.
    if (typeof(parameters.error) == 'function') {
      parameters.error = [parameters.error];
    }

    // Call each of the errors.
    for (let i = 0; i < parameters.error.length; i++) {
      parameters.error[i](request.responseText, request.status, parameters);
    }

  }

  let request = new XMLHttpRequest();

  let url = parameters.url;
  if (parameters.method == 'GET' && parameters.data) {
    let query_string = '?' + Object
      .keys(parameters.data)
      .map((key) => {
          return key + "=" + encodeURIComponent(parameters.data[key])
        })
      .join("&");
    url = parameters.url + query_string;
  }

  // Apparently using PATCH causes issues with some older browsers, so at
  // least for now we are sticking with POST (or GET).
  request.open(parameters.method, url);

  // Ensure we are calling a local URL (with a relative link) and if so send
  // the CSRF token in the header.
  if (parameters.method == 'POST' && url[0] == '/') {
    request.setRequestHeader("X-CSRFToken", getCookie('csrftoken'));
  }

  request.onload = function () {

    if (request.status === 200) {

      if (parameters.expected_response_type == 'json') {
        var response = JSON.parse(request.responseText);
      }
      else {
        var response = request.responseText;
      }

      // Allow for either a single function or list of callbacks.
      if (typeof(parameters.success) == 'function') {
        parameters.success = [parameters.success];
      }

      if (parameters.success) {
        for (let i = 0; i < parameters.success.length; i++) {
          parameters.success[i](response, request.status);
        }
      }

    }
    else {
      callErrorCallbacks();
    }
  };

  request.onerror = function () {
    callErrorCallbacks();
  };

  if (parameters.method == 'GET') {
    request.send();
  }
  else if (parameters.method == 'POST') {

    if (parameters.send_as_form_values) {
      let form_data = new FormData();
      Object.keys(parameters.data).forEach(key => {
        let value = parameters.data[key];
        if (value === null) { value = '' }
        form_data.append(key, value);
      });
      request.send(form_data);
    }
    else {
      request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      request.send(JSON.stringify(parameters.data));
    }

  }
}

/**
 * A regular form post request without the form for cases when we want to redirect.
 */
export var formPost = function (url, data) {

  // Ensure we are calling a local URL (with a relative link) and if so send
  // the CSRF token in the header.
  if (url[0] == '/') {
    data.csrfmiddlewaretoken = getCookie('csrftoken');
  }
  else {
    delete data.csrfmiddlewaretoken;
  }

  // Construct a form on the page.
  var form = document.createElement('form');
  document.body.appendChild(form);
  form.method = 'post';
  form.action = url;

  // Attach the data.
  for (let name in data) {
    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = data[name];
    form.appendChild(input);
  }

  form.submit();
}
